module.exports = __webpack_public_path__ + "img/premier-badge.52d145f1.png";